/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import { z } from 'zod';
const baseSchema = z.object({
    id: z.string(),
    name: z.string().nullish(),
    email: z.string(),
    emailVerified: z.boolean().default(false),
    image: z.string().nullish(),
    firstName: z.string().nullish(),
    lastName: z.string().nullish(),
    role: z.string().default("user"),
    banned: z.boolean().default(false),
    banReason: z.string().nullish(),
    banExpires: z.coerce.date().nullish(),
    lastLoginMethod: z.string().nullish(),
    createdAt: z.coerce.date().default(() => new Date()),
    updatedAt: z.coerce.date(),
}
).strict();
const baseSchemaWithoutDefaults = z.object({
    id: z.string(),
    name: z.string().nullish(),
    email: z.string(),
    emailVerified: z.boolean(),
    image: z.string().nullish(),
    firstName: z.string().nullish(),
    lastName: z.string().nullish(),
    role: z.string(),
    banned: z.boolean(),
    banReason: z.string().nullish(),
    banExpires: z.coerce.date().nullish(),
    lastLoginMethod: z.string().nullish(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
}
).strict();
const relationSchema = z.object({
    accounts: z.array(z.unknown()).optional(),
    sessions: z.array(z.unknown()).optional(),
    members: z.array(z.unknown()).optional(),
    profile: z.record(z.string(), z.unknown()).optional(),
    propertySeeker: z.record(z.string(), z.unknown()).optional(),
    impersonatorUser: z.array(z.unknown()).optional(),
    impersonatedUser: z.array(z.unknown()).optional(),
    impersonatorSessions: z.array(z.unknown()).optional(),
    impersonatedSessions: z.array(z.unknown()).optional(),
    sessionLogs: z.array(z.unknown()).optional(),
    avatarFile: z.record(z.string(), z.unknown()).optional(),
    usersFiles: z.array(z.unknown()).optional(),
    accessibleFiles: z.array(z.unknown()).optional(),
    savedListings: z.array(z.unknown()).optional(),
    comments: z.array(z.unknown()).optional(),
    replies: z.array(z.unknown()).optional(),
}
);

/**
 * `User` schema excluding foreign keys and relations.
 */
export const UserScalarSchema = baseSchema;


/**
 * `User` schema including all fields (scalar, foreign key, and relations) and validations.
 */
export const UserSchema = UserScalarSchema.merge(relationSchema.partial());


/**
 * Schema used for validating Prisma create input. For internal use only.
 * @private
 */
export const UserPrismaCreateSchema = baseSchemaWithoutDefaults.partial().passthrough();


/**
 * Schema used for validating Prisma update input. For internal use only.
 * @private
 */
export const UserPrismaUpdateSchema = z.object({
    id: z.string(),
    name: z.string().nullish(),
    email: z.string(),
    emailVerified: z.boolean(),
    image: z.string().nullish(),
    firstName: z.string().nullish(),
    lastName: z.string().nullish(),
    role: z.string(),
    banned: z.boolean(),
    banReason: z.string().nullish(),
    banExpires: z.coerce.date().nullish(),
    lastLoginMethod: z.string().nullish(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date()
}).partial().passthrough();


/**
 * `User` schema for create operations excluding foreign keys and relations.
 */
export const UserCreateScalarSchema = baseSchemaWithoutDefaults.partial({
    id: true, emailVerified: true, role: true, banned: true, createdAt: true, updatedAt: true
});


/**
 * `User` schema for create operations including scalar fields, foreign key fields, and validations.
 */
export const UserCreateSchema = baseSchemaWithoutDefaults.partial({
    id: true, emailVerified: true, role: true, banned: true, createdAt: true, updatedAt: true
});


/**
 * `User` schema for update operations excluding foreign keys and relations.
 */
export const UserUpdateScalarSchema = baseSchemaWithoutDefaults.partial();


/**
 * `User` schema for update operations including scalar fields, foreign key fields, and validations.
 */
export const UserUpdateSchema = UserUpdateScalarSchema;

